<template lang="pug">
.reserve-page
  .main-title
    .person
      .person-fullName
        .firstName Hello {{ $root.member.user_name }}
        .lastName {{ $root.member.name }}
      .person-avatar
        img.user-pic(:src="$root.member.user_picture", alt="alt")
    p 歡迎預約
  .sub-title 
    | 請選擇租借車輛類型和數量
  .reserve-car-value-list 
    .value-item(v-for="item in $root.register.carTypes" )
      .value-title {{ item.title }}
      .reserve-people(:class="{ on_focus: input_focus === item.id || item.amount }")
        input.people_number(
          :index="'car-item-' + item.id"
          type="number",
          @focus="onfocus(item.id)",
          @blur="onblur",
          placeholder="請輸入預約數量",
          :readonly="(item.id === 64)"
          v-model="(item.id === 64) ? 1 : item.amount"
          :data-itemId="item.id"
        )
  .button-group
    button.stepUp(type="button" @click="$router.go(-1)") 
      .step-txt 上一步
    button.stepNext(type="button" @click="goNext" :class="{active: people_number}") 
      .step-txt 下一步
</template>

<script>
export default {
  name: "reserve-page",
  components: {},
  data () {
    return {
      input_focus: false
    };
  },
  mounted () {
    this.people_number = this.$root.register.peoples
  },
  methods: {
    onfocus (_id) {
      this.input_focus = _id
    },
    onblur () {
      this.input_focus = false
    },
    goNext () {
      if (this.people_number) {
        this.$root.goPage('/reserve-page')
      }
    }
  },
};
</script>
<style lang="sass" scoped>
.reserve-page
  // margin-top: 74px
  padding: 48px 35px
  height: 100%
  overflow: auto
  .main-title
    .person
      display: flex
      justify-content: space-between
      align-items: center
      .person-fullName
        font-size: 32px
        font-weight: 700
        line-height: 2ex
        color: #fff
      .person-avatar
        width: 50px
        img
          width: 100%
          vertical-align: middle
    p
      font-size: 24px
      font-weight: 400
      color: #fff
      // padding-top: 13px
  .sub-title
    font-size: 18px
    font-weight: 700
    color: #898A8D
    padding-top: 34px
  .station-list
    color: #fff
    padding-top: 37px
    .station-item
      margin-bottom: 39px
      .station-pic
        width: 100%
        background-color: #535353
        border-radius: 10px 10px 0 0
        margin-inline: auto
        img
          padding: 52px
      .address-box
        padding-top: 8px
        .station-title
          font-size: 24px
          font-weight: 700
          color: #fff
        .address
          display: flex
          align-items: center
          gap: 8px
          .location-icon
            width: 12px
            height: 16px
            img
              width: 100%
  .reserve-car-value-list
    margin-top: 36px
    
    .value-item
      display: flex
      align-items: center
      justify-content: space-between
      margin-bottom: 36px
    .value-title
      color: #fff
      font-size: 5.2vmin

  .reserve-people
    border: 1.5px solid #505251
    border-radius: 0px
    height: 11vmin
    max-width: 50vmin
    
    .people_number
      width: 100%
      padding: 0 12px
      background: rgba(0,0,0,0)
      color: #fff
      font-size: 4.4vmin
      height: 10.5vmin
    &.on_focus
      border: 1.5px solid #22F48F

  .button-group
    padding-top: 15%
    display: flex
    .stepUp
      width: 40vmin
      margin: auto
      border-radius: 12.5vmin
      background-color: #fff
      border: none
      padding: 3vmin 0px
    .stepNext
      width: 40vmin
      margin: auto
      border-radius: 12.5vmin
      background-color: #898A8D
      border: none
      padding: 3vmin 0px
      &.active
        background-color: #22F48F
    .step-txt
      text-align: center
      font-size: 6vmin
      font-weight: 700
      color: #1E1E1E
</style>
